export enum TripsheetStatusEnum {
  DESBLOQUEADO = "Desbloqueado",
  BLOQUEADO = "Bloqueado",
  A_ASSINAR = "A Assinar",
  ASSINADO_1 = "Assinado 1",
  ASSINADO_2 = "Assinado 2",
  REJEITADO = "Rejeitado",
  CANCELADO_PRE_ASSINATURA = "Cancelado pré Assinatura",
  CANCELADO_POS_ASSINATURA = "Cancelado pós Assinatura",
}
